import * as React from 'react'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import {
  isAmazonMaturityRatingBadge,
  isRegulatoryRatingBadge,
  isLocalRatingBadge,
} from '../../utils/ratingBadgeHelper'
import { MaturityRating } from '@amzn/dvui/dist/MaturityRating'
import { Text } from '@amzn/dvui/dist/Text'

export interface IMaturityRatingBadgeProps {
  ratingBadge?: WpsRuntime.atv.wps.RatingBadgeProps
}

//TODO: AVWebDetailPage-2972
const ratingBadgeRender = (
  {
    displayText,
    description,
    localRatingLink
  }:
    | WpsRuntime.atv.wps.AmazonMaturityRatingBadgeProps
    | WpsRuntime.atv.wps.RegulatoryRatingBadgeProps,
) => {
  return(
    <MaturityRating rating={displayText.toUpperCase()} title={description} data-testid="rating-badge">
      {localRatingLink && (<Text string={localRatingLink} />)}
    </MaturityRating>
  )
}

const getLocalRatingBadge = (
  {
    countryCode,
    simplifiedId,
    description,
    localRatingLink
  }: WpsRuntime.atv.wps.LocalRatingBadgeProps) => {
  const locale = countryCode.toLowerCase()

  return (
    <MaturityRating rating={simplifiedId} locale={locale} title={description} data-testid="rating-badge" >
      {localRatingLink && (<Text string={localRatingLink} />)}
    </MaturityRating>
  )
}

export const Rating = ({ ratingBadge }: IMaturityRatingBadgeProps) => {
  if (!ratingBadge) {
    return null
  }

  if (isAmazonMaturityRatingBadge(ratingBadge) || isRegulatoryRatingBadge(ratingBadge)) {
    return ratingBadgeRender(ratingBadge)
  }

  if (isLocalRatingBadge(ratingBadge)) {
    return getLocalRatingBadge(ratingBadge)
  }

  return null
}
